:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

:host {
  --z3-accent-color: Highlight;
  --z3-accent-color-hover: Highlight;
  --z3-dropdown-z-index: 1000;
  --z3-dropdown-background: #fff;
  --z3-dropdown-box-shadow: 0 3px 6px rgba(0,0,0,0.22);
  --z3-dropdown-border-radius: 3px;
  --z3-dropdown-padding: 0.5rem 1rem;
  --z3-dropdown-padding-x: 1rem;
  --z3-dropdown-padding-y: 0.5rem;
  --z3-dropdown-padding-x-separator: 1rem;

  display: block;
  width: max-content;
  position: relative;
}

[hidden] {
  display: none !important;
}

.dropdown__trigger {
  cursor: pointer;
  width: 100%;
  min-width: min-content;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: inherit;
  background: none;
  border: none;
  padding: var(--z3-dropdown-padding);
}
.dropdown__trigger.open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.dropdown__trigger__text {
  margin-right: calc(var(--z3-dropdown-padding-x) / 2);
}

.dropdown__dropdown {
  display: block;
  width: max-content;
  max-width: calc(100vw - 30px);
  background: var(--z3-dropdown-background);
  border-radius: var(--z3-dropdown-border-radius);
  box-shadow: var(--z3-dropdown-box-shadow);
  opacity: 0;
  position: absolute;
  transition: opacity 0.3s ease;
  max-height: 75vh;
  overflow: auto;
  pointer-events: none;
  z-index: 10;
  min-width: 100%;
}
.dropdown__dropdown:not(.open) {
  max-width: 0;
}
.dropdown__dropdown.open {
  display: block;
  opacity: 1;
  pointer-events: auto;
}
.dropdown__dropdown.open {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.dropdown__trigger svg {
  transition: transform 0.3s ease;
}
.dropdown__trigger.open svg{
  transform: rotate(180deg);
}
